import type { Instance as TippyInstance } from 'tippy.js';

/**
 * Entrance animation for the @mention suggestion popover.
 *
 * Tippy's own animations live in `tippy.css`, which this repo deliberately never imports —
 * that stylesheet also themes the box and arrow, which `MentionList` styles itself. The
 * result was a popover with no transition at all: it simply appeared. Driving the entrance
 * from the Web Animations API keeps the stylesheet out of the bundle and works identically
 * in the portals and the extension side panel.
 */
export const MENTION_POPUP_ENTER_MS = 200;

export function animateMentionPopupIn(instance: TippyInstance): void {
  // Popper owns `transform` on `instance.popper` for positioning, so the animation has to
  // target the box it wraps or the popover drifts away from the caret while it plays.
  const box = instance.popper.firstElementChild as HTMLElement | null;
  if (!box || typeof box.animate !== 'function') return;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

  box.animate(
    [
      { opacity: 0, transform: 'translateY(-4px) scale(0.96)' },
      { opacity: 1, transform: 'translateY(0) scale(1)' },
    ],
    {
      duration: MENTION_POPUP_ENTER_MS,
      // Decelerating ease: most of the distance is covered early, so the list settles
      // rather than snapping.
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
    }
  );
}
